import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { Typography, Button, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { emailConfirmation } from '../lib/services/users';
import useService from '../hooks/useService';
import UPPage from '../components/UPPage';

/**
 * The page of email activate
 * @param props
 */
export default function(
  props: RouteComponentProps<{ uid: string; token: string }>
) {
  const { t } = useTranslation();
  const { isRequestDone, success, send } = useService(
    useCallback(
      () => emailConfirmation(props.match.params.uid, props.match.params.token),
      [props.match.params]
    )
  );

  useEffect(() => {
    send();
  }, [send]);

  if (!isRequestDone) {
    return <LinearProgress color="primary" />;
  }

  if (!success) {
    return (
      <UPPage>
        <Typography variant="body1" color="error">
          {t('emailConfirmationFailure')}
        </Typography>
      </UPPage>
    );
  }

  return (
    <UPPage>
      <Typography variant="body1">{t('emailConfirmationSuccess')}</Typography>
      <Button href="/auth" fullWidth variant="contained" color="primary">
        {t('goToAuthorizationPage')}
      </Button>
    </UPPage>
  );
}
